<script>
import CartItem from "@/components/CartItem.vue"
import { mapGetters } from 'vuex';
import CartSkeleton from "@/components/CartSkeleton.vue";
import CartSkeletonFooter from "@/components/CartSkeletonFooter.vue";
import OrderRequiredFieldsBottomSheet from "@/components/OrderRequiredFieldsBottomSheet.vue";

export default {
  components:{CartItem, CartSkeleton, CartSkeletonFooter, OrderRequiredFieldsBottomSheet},
  name: "CartBottomSheet",


  props: {
    orderIsActif: { type: Boolean, default: false },
    quoteIsActif: { type: Boolean, default: false },
  },

  data() {
    return {
      sheetHeight:100,
      isSheetOpen: false,
      showRequiredDataModal: false,
      errorBody: null
    };
  },

  computed:{
    ...mapGetters('cart', ['cart', 'isLoadingCart']),

    showCartItemDraft() {
      return Boolean(this.cart?.lines?.draft?.items?.length)
    },

    showCartItemSubmitted() {
      return Boolean(this.cart?.lines?.submitted?.items?.length)
    }

  },

  beforeDestroy() {
    window.onpopstate = null;
  },

watch: {
  isSheetOpen(val) {
    if (val) {
      history.pushState(null, null, location.href);
      window.onpopstate = () => {
        this.isSheetOpen = false;
        this.close();
      };
    } else {
      window.onpopstate = null;
    }
  }
},

  
  methods: {

    closeOrderRequiredDataSheet(){
      this.showRequiredDataModal = false
    },

    closeSheet(){
      this.isSheetOpen = false;
      this.$emit("closeSheet");
    },

    close() {
      this.isSheetOpen = false;
      this.$refs.cartSheet.close();
      this.closeSheet()
    },
    open() {
      this.isSheetOpen = true;
      this.$refs.cartSheet.open();
    },
    expandSheet() {
        this.$nextTick(() => {
            this.$refs.cartSheet.open();
        });
    },

    handelCheckout(customerDataInformation){
      this.checkout(customerDataInformation)
    },

    checkout(customerDataInformation) {

      customerDataInformation.paymentMethod = 0,
      customerDataInformation.message= ""

     this.$store.dispatch('cart/checkoutOrder', customerDataInformation)
     .then(() => {
        this.close()
      })
      .catch((error) => {
        const status = error?.status;
          if(status === 428){
            this.showRequiredDataModal = true;
            this.errorBody = error;
                  this.$refs.orderRequiredFieldsSheet.open();

          }
      });
    },

  },
};
</script>
<template>
  <vue-bottom-sheet-vue2
    ref="cartSheet"
    :max-width="500"
    :init-sheet-height="2000"
    :max-height="2000"  
    :swipe-able="false"
    overlay-color="rgba(0,0,0,0.6)"
    @closed="closeSheet()"
  >

    <template #drag v-if="this.orderIsActif || this.quoteIsActif">
        <div class="d-flex align-items-center justify-content-between w-100 mt-2 mb-2">
          <b-button  @click="close()" variant="light" class="ml-4" style="touch-action: manipulation;">
                <img alt="arrowLeft" width="20" src="@/assets/icons/arrow-left-black.svg" @click="close()"/>
            </b-button>
          <h5  v-if="orderIsActif && !quoteIsActif" class="text-center text-dark text-uppercase flex-grow-1 m-0 mr-4">{{  $t('menuOrder.cart.title') }}</h5>
          <h5  v-if="!orderIsActif && quoteIsActif" class="text-center text-dark text-uppercase flex-grow-1 m-0 mr-4">{{  $t('menuOrder.cart.quoteTitle') }}</h5>
        </div>
    </template>

    <template #header v-if="false" >
       
    </template>

    <template #default >

      <div v-if="!orderIsActif && !quoteIsActif">
        <CartSkeleton :rows="6" />
      </div>

      <div v-else> 
        <b-collapse v-if="showCartItemDraft" :visible="true" class="mt-3">
          <div class="font-size-12 text-uppercase font-weight-bold mb-2 ml-2 mt-0 mb-3 text-dark" >
            {{ cart.lines.draftCountItems }} article(s) à commander
          </div>
          <ul class="list-unstyled mb-2">
            <CartItem
              v-for="item in cart.lines.draft.items"
              :key="item.orderLineId"
              :item="item"
              :isQuoteMenu="quoteIsActif"
            />
          </ul>
        
        </b-collapse>

        <b-collapse v-if="showCartItemSubmitted" :visible="true" class="mt-4 bg-light m-2" 
          style="margin-bottom: 80px; border: 1px dashed #333; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);

          
          ">
          <div class="font-size-12 text-uppercase font-weight-bold mb-2 mt-2 ml-2 text-dark" >
            {{ cart.lines.submittedCountItems }} article(s) en cours de préparation
          </div>
          <ul class="list-unstyled mb-2" style="opacity:0.6">
            <CartItem 
              v-for="item in cart.lines.submitted.items"
              :key="item.orderLineId"
              :item="item"
              :disabled="true" style="opacity:1"
              :isQuoteMenu="quoteIsActif"
            />
          </ul>

        </b-collapse>

        <!-- some padding to make buttons visible -->
        <div class="mb-5 pb-5">
        </div>
      </div>


    </template>

    <template #footer v-if="this.showCartItemDraft || this.showCartItemSubmitted" >
    
      <div v-if="!orderIsActif && !quoteIsActif  ">
        <CartSkeletonFooter />
      </div>


        <div v-if="orderIsActif && !quoteIsActif" class="p-3 border-top bg-white d-flex justify-content-between align-items-center footer" style="box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2) !important;">
            <div class="font-weight-bold text-dark" style="font-size: 1rem;">
            {{ cart.lines.cartTotal }}
            </div>

            <b-button  @click="checkout" :disabled="cart && cart.lines && cart.lines.draftCountItems == null || cart.lines.draftCountItems == 0" variant="light" class="btn-pill text-white font-size-16 font-weight-bold text-uppercase checkout-btn position-relative" style="  letter-spacing: 0.1rem;">
                {{ $t('menuOrder.cart.button.submitOrder') }}
            </b-button>
        </div>

        
        <div v-if="!orderIsActif && quoteIsActif" class="p-3 border-top bg-white d-flex justify-content-center align-items-center footer" style="box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2) !important;">
            <b-button  @click="checkout" :disabled="cart && cart.lines && cart.lines.draftCountItems == null || cart.lines.draftCountItems == 0" 
              variant="light" 
              class="btn-pill text-white font-size-16 font-weight-bold text-uppercase checkout-btn position-relative" 
              style="  letter-spacing: 0.1rem;">
                {{ $t('menuOrder.cart.button.submitQuote') }}
            </b-button>
        </div>

    <OrderRequiredFieldsBottomSheet
      ref="orderRequiredFieldsSheet"
      v-show="showRequiredDataModal"
      @closeOrderRequiredDataSheet="closeOrderRequiredDataSheet"
      @checkout="handelCheckout"
      :errorBody= errorBody
      :draftCountItems = cart.lines.draftCountItems
      :cartTotal="cart.lines.cartTotal"
    />


    </template>

  </vue-bottom-sheet-vue2>
</template>

<style>

.checkout-btn {
  border-radius: 25px;
  padding: 0.6rem 1.9rem;
  background: linear-gradient(90deg, #28a745, #218838);
  transition: all 0.2s;
}

.bottom-sheet__header .bottom-sheet__draggable-area {
  padding:  10px 0px 0px 0px !important;
}
</style>